import React, { Component } from "react";
import Select from "react-select";
import { SkyLightStateless } from 'react-skylight';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Grid,
  Row,
  Col,
  Panel,
  Button,
  Tabs,
  Tab,
  ButtonToolbar,
  Breadcrumb,
  Dropdown,
  MenuItem,
  Input,
} from "react-bootstrap";
import { Translate } from "react-redux-i18n";
import { Toolbar, Data } from "react-data-grid-addons";
import ReactDataGrid, { prototype } from "react-data-grid";
// import { fetchZones, fetchBins, fetchLevels } from './api';

import axios from 'axios';
import {
  ROOT_URL, //https://abc-scm.truckxi.com/api/
} from '../../../../actions/root_url';
import {
  createWebUser
} from './apis';

const modalStyle = {
  width: '300px',
  height: '360px',
  marginLeft: '-7%',
  marginTop: '-12%',
}

const propTypes = {
  isVisible: PropTypes.bool,
  setModalVisibility: PropTypes.array,
  onConfirm: PropTypes.func,
}

const defaultProps = {
  isVisible: false,
  setModalVisibility: () => {},
  onConfirm: () => {},
  selectedRows: [],
}

const prcessZoneData = (zones) => {
  return zones.map(zone => ({
    label: zone.Name,
    value: zone.id,
  }))
}

const prcessBinData = (bins) => {
  return bins.map(bin => ({
    label: bin.section_num,
    value: bin.id,
  }))
}

const processLevelData = (levels) => {
  return levels.map(level => ({
    label: level.bin_num,
    value: level.id,
    color: level.color,
  }));
}

const initialTableData = {
  rows: [],
  selectedRow: {
    label: '',
    value: '',
  }
}

class RowRenderer extends Component {
  PropTypes: {
      onDoubleClick: React.PropTypes.func
  };
  render() {
    return (<div onDoubleClick={() => { this.props.onDoubleClick(this.props.row); }}><ReactDataGrid.Row ref="row" {...this.props} /></div>);
  }
}

class LocationSelect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      phone: '',
    };
  }

  componentDidMount() {
    // this.fetchZones();
  }

  handleConfirmClick = () => {
    const {
      selectedRows,
    } = this.props;
    let id = selectedRows[0] ? selectedRows[0].Customer_id : null;
    const success = () => {
      alert('success');
      this.props.setModalVisibility();
    }
    const failed = () => {
      alert('failed');
    }
    createWebUser(id, this.state, success, failed)
  }

  renderLevelTable = () => {
    const getRows = () => Data.Selectors.getRows(this.state.levelTable);
    const getSize = () => getRows().length;
    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return Object.assign({}, rows[rowIdx]);
    };

    const columns = [{
      key: 'label',
      name: <Translate value="level" />,
      resizable: true,
      sortable: true,
      // width: 200,
      filterable: true,
    }];

    return (
      <ReactDataGrid
        rowRenderer={<RowRenderer onDoubleClick={this.handleLevelSelect} />}
        columns={columns}
        rowGetter={rowGetter}
        rowsCount={getSize()}
      />
    )
  }


  handleInputChange = (field, { target }) => {
    const {
      value
    } = target;
    this.setState({
      [field]: value,
    })
  }

  render() {
  
    return (
      <div style={{ width: '100%', height: '100%', padding: '10px', padding: '30px' }}>
        <div style={{ display: 'flex', fontSize: '40px', flexDirection: 'row', textAlign: 'center', justifyContent: 'center', alignItems: 'center' }}>
          {/* <div style={{ paddingRight: '10px' }}>Selected Location:  </div> */}
          {/* <div>{this.generateSelectedLocation()}</div> */}
        </div>
        <div>
          <div>
            <span><Translate value="email"/>: </span>
            <Input type='text' value={this.state.email} onChange={e => this.handleInputChange('email', e)}/>
          </div>
          <div>
            <span><Translate value="password"/>: </span>
            <Input type='password' value={this.state.password} onChange={e => this.handleInputChange('password', e)}/>
          </div>
          <div>
            <span><Translate value="phone"/>: </span>
            <Input type='text' value={this.state.phone} onChange={e => this.handleInputChange('phone', e)}/>
          </div>
        </div>
        <div style={{ width: '100%', justifyContent: 'end', alignContent: 'end', textAlign: 'end', alignItems: 'end', paddingTop: '40px' }}>
          <Button
            bsStyle="primary"
            className="print-btn"
            type="button"
            // disabled={selectedRows.length !== 1}
            onClick={this.handleConfirmClick}
          >
            {/* <em className="fa fa-pencil" /> */}
            <Translate value="confirm" />
          </Button>
        </div>
      </div>
    )
  }
}

const WebUserModal = ({ setModalVisibility, isVisible, onConfirm, selectedRows }) => (
  <SkyLightStateless
    title={'Web User'}
    onCloseClicked={setModalVisibility}
    dialogStyles={modalStyle}
    isVisible={isVisible}
  >
    <LocationSelect onConfirm={onConfirm}  setModalVisibility={setModalVisibility} selectedRows={selectedRows} />
  </SkyLightStateless>
)

WebUserModal.propTypes = propTypes
WebUserModal.defaultProps = defaultProps

export default WebUserModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/generalManagement/WebUserModal.jsx